

































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { EPLModule } from '@/store/eplmodule'
import { DictRequest, DictParam, DictOptions, DictFilter, DictList } from '@/types'
import moment from 'moment'

@Component({
  name: 'Calendar',
  components: {
    DictForm: () =>
      import(/* webpackChunkName: "DictForm" */ '@/components/DictForm.vue'),
    CalendarSchedule: () =>
      import(/* webpackChunkName: "CalendarSchedule" */ '@/components/CalendarSchedule.vue')
  }
})
export default class Calendar extends Vue {
  idx = -1
  saveForm = false
  needUpdateTable = false
  tableHeight = '100%'
  show = false
  rows = [] as any
  dates = [] as Array<string>
  tab = null
  selectedEntUnits = [] as DictList
  selectedTC = []
  selectedDrivers = []
  inUpdate = false

  pickerFrom = false
  pickerTo = false
  dateFrom = moment().format('YYYY-MM-DD')
  dateTo = moment().format('YYYY-MM-DD')
  tzoffset = 0

  get entUnits () {
    return EPLModule.lists['CUTUNITS-CUTUNITS' as any]
  }

  get itemsTC () {
    return EPLModule.lists['Transport-gosnumber,marka' as any]
  }

  get drivers () {
    return EPLModule.lists['Drivers-name' as any]
  }

  get dict () {
    return EPLModule.dicts[this.idx]
  }

  get calendar () {
    return EPLModule.dicts[this.idx].rows
  }

  private clickClose () {
    EPLModule.hideDictForm(this.idx)
  }

  get isShowForm () {
    if (!this.dict.isShowForm) {
      if (this.needUpdateTable) {
        this.needUpdateTable = false
        this.getData()
      }
    }
    return this.dict.isShowForm
  }

  public updateTable () {
    this.needUpdateTable = true
  }

  private create () {
    if (this.selectedTC.length > 0) {
      const stc = [] as Array<string>
      this.selectedTC.forEach((e: any) => {
        stc.push(e.value)
      })
      EPLModule.clrCalendarEx({
        beg: this.getUnixTime(this.dateFrom),
        end: this.getUnixTime(this.dateTo) + 86399,
        tc: stc
      })
        .then(() => {
          EPLModule.makeCalendarEx({
            beg: this.getUnixTime(this.dateFrom),
            end: this.getUnixTime(this.dateTo) + 86399,
            tc: stc
          })
            .then(() => {
              this.getData()
            })
        })
    } else {
      EPLModule.clrCalendar({ beg: this.getUnixTime(this.dateFrom), end: this.getUnixTime(this.dateTo) + 86399 })
        .then(() => {
          EPLModule.makeCalendar({ beg: this.getUnixTime(this.dateFrom), end: this.getUnixTime(this.dateTo) + 86399 })
            .then(() => {
              this.getData()
            })
        })
    }
  }

  private clear () {
    if (confirm('Удалить календарь за выбранный период?')) {
      if (this.selectedTC.length > 0) {
        const stc = [] as Array<string>
        this.selectedDrivers.forEach((e: any) => {
          stc.push(e.value)
        })
        EPLModule.clrCalendarEx({
          beg: this.getUnixTime(this.dateFrom),
          end: this.getUnixTime(this.dateTo) + 86399,
          tc: stc
        })
          .then(() => {
            this.getData()
          })
      } else {
        EPLModule.clrCalendar({ beg: this.getUnixTime(this.dateFrom), end: this.getUnixTime(this.dateTo) + 86399 })
          .then(() => {
            this.getData()
          })
      }
    }
  }

  get hasEntUnits () {
    return EPLModule.user.entunits !== ''
  }

  async mounted () {
    this.tzoffset = new Date().getTimezoneOffset() * 60
    this.idx = EPLModule.DictIdx('Calendar')
    this.reSize()
    window.addEventListener('resize', this.reSize)
    await EPLModule.fetchList({ dict: 'CUTUNITS', sourcetext: 'CUTUNITS', sourcevalue: 'qwe' })
    this.selectedEntUnits = [] as DictList
    if (this.hasEntUnits) {
      EPLModule.user.entunits.split(',').forEach((v) => {
        this.entUnits.forEach((e) => {
          if (e.value === v) {
            this.selectedEntUnits.push(e)
          }
        })
      })
    } EPLModule.fetchList({ dict: 'Transport', sourcetext: 'gosnumber,marka', sourcevalue: 'uid' })
    EPLModule.fetchList({ dict: 'Drivers', sourcetext: 'name', sourcevalue: 'uid' })
    this.getData()
  }

  private getSelectValue (value: string | number, list: any): string {
    let result = ''
    if (EPLModule.lists[list]) {
      EPLModule.lists[list].forEach((i: any) => {
        if (i.value === value || i.value === `${value}`) {
          result = i.text
        }
      })
    }
    return result
  }

  private editCell (id: number) {
    EPLModule.showDictForm({ id: id, idx: this.idx })
  }

  private extractTC () {
    this.calendar.forEach(e => {
      const d = moment.unix(e.day).format('DD.MM.YYYY')
      const begin = moment.unix(e.begin).format('HH:mm')
      const end = moment.unix(e.end).format('HH:mm')
      let idx = -1
      this.rows.forEach((r: any, i: number) => {
        if (r.transport === e.transport) {
          idx = i
        }
      })
      if (idx === -1) {
        // такого ТС ещё не было
        this.rows.push({
          transport: e.transport,
          transportf: e['gosnumber,markatransport-f'],
          data: [{
            shift: e.shift,
            data: [{
              date: d,
              graph: e.graph,
              graphf: e['Namegraph-f'],
              begin: begin,
              end: end,
              driver: e.driver,
              driverf: e['namedriver-f'],
              vacation: e.vacation,
              id: e.id
            }]
          }]
        })
      } else {
        // ТС уже есть, ищем смену
        let idxs = -1
        this.rows[idx].data.forEach((s: any, si: number) => {
          if (s.shift === e.shift) {
            idxs = si
          }
        })
        if (idxs === -1) {
          // такой смены у этого ТС ещё не было
          this.rows[idx].data.push({
            shift: e.shift,
            data: [{
              date: d,
              graph: e.graph,
              graphf: e['Namegraph-f'],
              begin: begin,
              end: end,
              driver: e.driver,
              driverf: e['namedriver-f'],
              vacation: e.vacation,
              id: e.id
            }]
          })
        } else {
          // смена есть, добавим график и дату
          this.rows[idx].data[idxs].data.push({
            date: d,
            graph: e.graph,
            graphf: e['Namegraph-f'],
            begin: begin,
            end: end,
            driver: e.driver,
            driverf: e['namedriver-f'],
            vacation: e.vacation,
            id: e.id
          })
        }
      }
    })
  }

  private getData () {
    this.selectedTC.forEach((e: any, i: number) => {
      if (typeof e !== 'object') {
        this.selectedTC.splice(i, 1)
      }
    })
    this.selectedEntUnits.forEach((e: any, i: number) => {
      if (typeof e !== 'object') {
        this.selectedEntUnits.splice(i, 1)
      }
    })
    this.selectedDrivers.forEach((e: any, i: number) => {
      if (typeof e !== 'object') {
        this.selectedDrivers.splice(i, 1)
      }
    })

    if (this.inUpdate) return
    this.inUpdate = true
    this.rows.splice(0, this.rows.length)
    const p = {} as DictParam
    p.idx = this.idx
    p.request = {} as DictRequest
    p.request.options = {} as DictOptions
    p.request.options.page = 1
    p.request.options.itemsPerPage = -1
    p.request.options.sortBy = ['transport', 'shift']
    p.request.options.sortDesc = [false, false]
    const entUnits = [] as Array<string>
    this.selectedEntUnits.forEach((e: any) => {
      entUnits.push(e.value)
    })
    p.request.entunits = entUnits
    p.request.filter = [] as Array<DictFilter>
    if (this.dateFrom !== '' && this.dateTo !== '') {
      this.dates.splice(0, this.dates.length)
      const beg = moment.unix(this.getUnixTime(this.dateFrom))
      const end = moment.unix(this.getUnixTime(this.dateTo))
      const days = moment.duration(end.diff(beg)).asDays()
      this.dates.push(moment.unix(this.getUnixTime(this.dateFrom)).format('DD.MM.YYYY'))
      for (let i = 0; i < days; i++) {
        this.dates.push(beg.add(1, 'days').format('DD.MM.YYYY'))
      }
      const from = {} as DictFilter
      from.field = 'day'
      from.condition = `${this.getUnixTime(this.dateFrom)}`
      from.operator = '>='
      from.combine = 'AND'
      p.request.filter.push(from)
      const to = {} as DictFilter
      to.field = 'day'
      to.condition = `${this.getUnixTime(this.dateTo) + 86399}`
      to.operator = '<='
      to.combine = 'AND'
      p.request.filter.push(to)
      if (this.selectedTC.length > 0) {
        const stc = [] as Array<string>
        this.selectedTC.forEach((e: any) => {
          stc.push(e.value)
        })
        if (stc.length > 0) {
          let condtc = JSON.stringify(stc)
          condtc = condtc.replace(/"/g, '\'')
          condtc = condtc.replace('[', '(')
          condtc = condtc.replace(']', ')')
          const tc = {} as DictFilter
          tc.field = 'transport'
          tc.condition = condtc
          tc.operator = 'IN'
          tc.combine = 'AND'
          p.request.filter.push(tc)
        }
      }
      if (this.selectedDrivers.length > 0) {
        const sdrv = [] as Array<string>
        this.selectedDrivers.forEach((e: any) => {
          sdrv.push(e.value)
        })
        if (sdrv.length > 0) {
          let condd = JSON.stringify(sdrv)
          condd = condd.replace(/"/g, '\'')
          condd = condd.replace('[', '(')
          condd = condd.replace(']', ')')
          const drv = {} as DictFilter
          drv.field = 'driver'
          drv.condition = condd
          drv.operator = 'IN'
          drv.combine = 'AND'
          p.request.filter.push(drv)
        }
      }
    }
    EPLModule.fetchDictData(p)
      .then(() => {
        this.extractTC()
        this.inUpdate = false
        this.show = true
      })
  }

  private getUnixTime (date: string): number {
    return parseInt(
      ((new Date(date).getTime() / 1000) + this.tzoffset).toFixed(0)
    )
  }

  get dateFormattedFrom () {
    return moment.unix(this.getUnixTime(this.dateFrom)).format('DD.MM.YYYY')
  }

  get dateFormattedTo () {
    return moment.unix(this.getUnixTime(this.dateTo)).format('DD.MM.YYYY')
  }

  private reSize () {
    const k = 270
    this.tableHeight = `${window.innerHeight - k}px`
  }
}
